import OnSalePropertiesError from './BricksReservationError';
class TraderDoesNotHasBricksReservation extends OnSalePropertiesError {
    constructor() {
        super('Trader does not has bricks reservation');
    }
}
export default TraderDoesNotHasBricksReservation;
